import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import api from '../../../../utils/api';

const AppointmentScheduleModal = ({
  show,
  onHide,
  roomId,
  clientData,
 
}) => {
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [submissionError, setSubmissionError] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state for button
 console.log("clientData",clientData);
 
  const createPortfolioMeeting = async (payload) => {
    return api.post(`advisor/portfolio_meeting_pr`, payload);
  };

  const updateClientPRData = async (payload) => {
    return api.post(`advisor/updateprdataWM`, payload);
  };

  const updateClientPRDataStep2 = async (payload) => {
    return api.post(`advisor/updateprdataWM`, payload);
  };

  const onSubmit = async (data) => {
    // try {
    //   if (!startDate || !endDate) {
    //     setSubmissionError("Please select both start and end dates.");
    //     return;
    //   }

    //   setLoading(true); // Start loading

    //   const payload1 = {
    //     client_id: roomId,
    //     Start_DateTime: startDate.toISOString(),
    //     End_DateTime: endDate.toISOString(),
    //   };

    //   const response1 = await createPortfolioMeeting(payload1);

    //   const payload2 = {
    //     clientid: roomId,
    //     pr_id: isPortfolioData?.prinfo.portfolio_review_id,
    //     step: 51,
    //     prsteps_selected:prsteps_selected,
    //     action: "whyReblance",
    //     toggle_: 0,
    //   };

    //   const response2 = await updateClientPRData(payload2);

    //   const payload3 = {
    //     clientid: roomId,
    //     pr_id: isPortfolioData?.prinfo.portfolio_review_id,
    //     prsteps_selected:prsteps_selected,
    //     step: 52,
    //     action: "whyReblance",
    //     toggle_: 0,
    //   };

    //   const response3 = await updateClientPRDataStep2(payload3);
    //   // handlePrSubmit()
      
    //   setPrsuggections(response3?.data?.prsuggections);

    //   setSubmissionError(null);
    //   handleClose();

    //   if (selectedTab < 4) {
    //     setSelectedTab(selectedTab + 1);
    //   }

    //   setLoading(false); // End loading
    // } catch (error) {
    //   console.error('Error during API calls:', error);
    //   setSubmissionError("An error occurred while scheduling the appointment. Please try again.");
    //   setLoading(false); // End loading in case of error
    // }
  };

  const handleClose = () => {
    reset(); // Reset form fields
    setStartDate(null); // Reset start date
    setEndDate(null);   // Reset end date
    setSubmissionError(null); // Clear submission errors
    onHide(); // Close the modal
  };


  // const handlePrSubmit = async () => {
  //   try {
  //     const allData= {
  //       clientid: roomId,
  //       pr_id: isPortfolioData?.prinfo?.portfolio_review_id,
  //       step: 51,
  //       prsteps_selected:prsteps_selected,  
  //       action: "whyReblance",
  //       toggle_: 0
  //     }
  //     console.log("allData",allData);
      
  //     const response = await axios.post(`advisor/updateprdata`, {
  //       allData
  //     });
  
  //     if (response.status === 200) {
  //       console.log("Data submitted successfully:", response.data);
       
  //     }
  //   } catch (error) {
  //     console.error("Error submitting data:", error);
     
  //   }
  // };

  return (
    <Modal show={show} onHide={handleClose} className="custom-sm-modal" centered>
      <Modal.Header closeButton style={{ backgroundColor: "#fff", border: 'none' }}>
        <Modal.Title>Schedule an Appointment</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-6">
              <Form.Group controlId="startDate">
                <Form.Label>Select Start Date and Time</Form.Label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                    setValue("startDate", date, { shouldValidate: true });
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="dd/MM/yyyy hh:mm aa"
                  className="form-control verify3"
                  placeholderText="Select Start Date & Time"
                />
                {errors.startDate && <p className="text-danger">{errors.startDate.message}</p>}
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group controlId="endDate">
                <Form.Label>Select End Date and Time</Form.Label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => {
                    setEndDate(date);
                    setValue("endDate", date, { shouldValidate: true });
                  }}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="dd/MM/yyyy hh:mm aa"
                  className="form-control verify3"
                  placeholderText="Select End Date & Time"
                />
                {errors.endDate && <p className="text-danger">{errors.endDate.message}</p>}
              </Form.Group>
            </div>
          </div>

        
          <Form.Group controlId="subject" className='mt-2'>
            <Form.Label>Subject</Form.Label>
            <Form.Control 
              className='refer'
              type="text" 
              value='Portfolio Review Discussion'
              disabled
              // {...register("subject", { required: "Subject is required" })}
            />
          
          </Form.Group>

          {submissionError && (
            <Alert variant="danger" className="mt-3">
              {submissionError}
            </Alert>
          )}

          <Modal.Footer>
            <button 
              type="submit" 
              className="lrgbutton upercase w-100 text-white" 
              disabled={loading} // Disable the button while loading
            >
              {loading ? "Processing..." : "Submit"} {/* Show "Processing..." when loading */}
            </button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AppointmentScheduleModal;
